import { useModalStore } from '../../store/modalStore';
import { useToastStore } from '../../store/toastStore';
import { useDeleteVideoGroup } from '../../hooks/useVideos';
import type { VideoGroup } from '../../api/videos';

export function DeleteVideoGroupModal() {
  const { isOpen, modalType, modalData, closeModal } = useModalStore();
  const addToast = useToastStore((state) => state.addToast);
  const deleteMutation = useDeleteVideoGroup();

  const group = modalData as VideoGroup;
  const open = isOpen && modalType === 'deleteVideoGroup' && !!group;

  if (!open) return null;

  const deleting = deleteMutation.isPending;
  const count = group.videoCount;

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(group.id);
      addToast('Group deleted', 'success');
      closeModal();
    } catch (err) {
      addToast((err as Error).message || 'Failed to delete group', 'error');
    }
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Delete Group</h2>
          <button onClick={closeModal} className="btn-close" type="button">
            ×
          </button>
        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to delete <strong>{group.title}</strong>?
          </p>
          {count > 0 && (
            <p>
              Its {count} {count === 1 ? 'video' : 'videos'} will remain and become
              ungrouped — they will not be deleted.
            </p>
          )}
          <p className="warning">This action cannot be undone.</p>
        </div>

        <div className="modal-footer">
          <button onClick={closeModal} className="btn btn-secondary" type="button">
            Cancel
          </button>
          <button
            onClick={() => void handleDelete()}
            className="btn btn-danger"
            disabled={deleting}
            type="button"
          >
            {deleting ? 'Deleting...' : 'Delete Group'}
          </button>
        </div>
      </div>
    </div>
  );
}
